/**
 * @file: MemberAccountWithdrawBody.tsx
 *
 * `OrgMemberAccountWithdraw` — a member-account withdrawal cleared.
 * Mirror of the deposit body but tinted neutral (no green for an
 * outgoing balance).
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrgMemberAccountWithdrawFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { formatYuan } from './common/labels';

export const MemberAccountWithdrawBody: FC<{
  p: OrgMemberAccountWithdrawFeedPayload;
}> = ({ p }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View>
      <View
        css={`
          flex-direction: row;
          align-items: baseline;
        `}
      >
        <Typography.Text size={rpx(22)} color="#1f2937" bold>
          −¥{formatYuan(p.amount)}
        </Typography.Text>
        <Typography.Text ml={rpx(8)} size={rpx(12)} color="#6b7280">
          已提现
        </Typography.Text>
      </View>
      <Typography.Text mt={rpx(4)} size={rpx(12)} color="#6b7280">
        账户余额 ¥{formatYuan(p.balance)}
      </Typography.Text>
    </View>
  );
};
